import type React from "react";
import { AuthContext, type AuthContextProps } from "react-oidc-context";

/**
 * Provides a static AuthContext for router modes that don't use OIDC (hub, regional).
 * Shared components (TopBar, BurgerMenu, etc.) destructure `isAuthenticated` from useAuth()
 * — this gives them a stable `false` without initializing oidc-client-ts.
 */
const noAuthContextValue = {
  isAuthenticated: false,
  isLoading: false,
  user: null,
} as unknown as AuthContextProps;

const NoAuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <AuthContext.Provider value={noAuthContextValue}>
    {children}
  </AuthContext.Provider>
);

export default NoAuthProvider;
